import React from 'react'

import { Row , Col, Container, Button } from 'react-bootstrap'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {   faCircleUser, faUser, faXmarkCircle , faFileInvoice } from '@fortawesome/free-solid-svg-icons'
import axios from 'axios'

import  {ApiCallPost}  from '../ApiCall/ApiCall'

function LoadCodigoAgrupador({close}) {

    async function formSubmit( e )
    {
        e.preventDefault() ;

        //return ;

        console.log( "LoadCodigoAgrupador")

        const theFile = document.getElementById( "uploadcodigo").files[0] ;

        const reader = new FileReader() ; 



        reader.readAsText(theFile , "ISO-8859-1") ;

        console.log( "Antes de onLoad") ;

        reader.onload = async (e) => {
            const data2 = e.target.result ;


            console.log( "Handle upload " + data2) ;

        

            var fullData = {
                data : data2
            }

            await ApiCallPost( "codigoagrupador" ,  fullData )
        }
        return ;


    

    }

    function onClose()
    {
        close() ;
    }

    function handleUpload(e)
    {



    }

  return (
    <Container className='d-flex flex-column align-items-center '  >
    
    <div className=" d-flex flex-column justify-content-center box-1 backemployer-2 mb-5" 
        style={{paddingTop:'31px' , width :'75%' }} > 
    
        <form onSubmit={formSubmit}>


        <Row >
            <Col className='col-11'>
                <div style={{display:'flex'}} >
                    <FontAwesomeIcon icon={faFileInvoice} style={{color:'grey' , height:20 , paddingTop:'5px'}}/>
                    <p style={{fontSize:'20px' , paddingLeft : '5px' , marginBottom : '2px'}}>Carga de Código Agrupador</p>
                </div>
                
            </Col>
            
            
            <Col className='col-1'>
                <FontAwesomeIcon className='pt-2 ps-2' onClick={onClose} icon={faXmarkCircle} 
                title='Close' style={{color:'gray' , height:25 }}/>
            </Col>

        </Row>


        <Row>    
            <label htmlFor="uploadcodigo">Seleccione Archivo CSV:</label>
            <input id="uploadcodigo" type='file' name="archivo" accept='.csv' onChange={handleUpload}/>
        </Row>


        <Row>    
            <Button type='submit'>Cargar</Button>
            
        </Row>

    
        </form>
    </div>



    </Container>
  )
}

export default LoadCodigoAgrupador